var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fragment"},[_vm._v(" "+_vm._s(/* to be removed in vue3 (fragment) */)+" "),_c('x-container',[_c('partner-service-contract-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }